/**
 * Sanity ceiling on the per-share repurchase price an operator types into the termination modal.
 *
 * Far above any real price, and low enough that a mistyped figure is rejected at the boundary
 * rather than persisted as a settled `compensation` nobody can explain — nothing downstream bounds
 * it, since `ReverseVestingTerminationService.resolveRepurchasePrice` only rejects a negative price
 * and the product is stored on the row.
 *
 * Shared rather than mirrored per package for the same reason
 * `validateReverseVestingSchedule` is: the frontend applies this so the operator gets an inline
 * field error, and the backend re-applies it because the frontend is not a trust boundary. Two
 * hand-copied copies drift, and a drift here turns into a backend 400 on a payload the modal
 * accepted.
 */
export const MAX_REVERSE_VESTING_REPURCHASE_PRICE = 1e9;
